import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { CCAuthService } from '@heidelberg/control-center-frontend-integration/auth';
import { ROUTE_PARAMS, ROUTE_PARAMS_PLACEHOLDERS, ROUTE_PATH } from '@data-terminal/shared-models/navigation';

export const canActivateNotificationsSettingsGuard: CanActivateFn = (
    route: ActivatedRouteSnapshot
): boolean | UrlTree => {
    const router = inject(Router);
    const sessionService = inject(CCAuthService);

    const orgId = route.parent?.params[ROUTE_PARAMS.orgId];

    if (orgId === ROUTE_PARAMS_PLACEHOLDERS.orgIdPlaceholder) {
        const actualOrgID = sessionService.getCurrentMembership()?.organizationId || '';

        return router.createUrlTree([`/${actualOrgID}/${ROUTE_PATH.notifications}`]);
    }
    return true;
};
